export default "__VITE_ASSET__CWj1wh$f__ 100w";